import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {Globals} from '../../../global/global.model';
import {Cuotas} from './cuotas.model';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';


@Injectable()
export class CuotasServices {

	constructor(private http: HttpClient) { }

	getDataCuotas():Observable<Cuotas[]>{
		return this.http.get<Cuotas[]>(Globals.BASE_URL_API_REST+'cuotas.json');
	}

	saveCuotas(data:Cuotas){
		return this.http.post(Globals.BASE_URL_API_REST+'cuotas.json',data);
	}

	deleteCuotas(id:number){
		return this.http.delete(Globals.BASE_URL_API_REST+'cuotas/'+id+'.json');
	}

	updateCuotas(data:Cuotas){
		 return this.http.patch(Globals.BASE_URL_API_REST+'cuotas/'+data.id+'.json',data);
	}

	viewCuotas(id:number){
		 return this.http.get(Globals.BASE_URL_API_REST+'cuotas/'+id+'.json');
	}
}